import type { QRScanResult } from '../app/components/QRScanner';

/**
 * Path the app should land on after a successful scan.
 * A named gun rides as a query param so the charge-point sheet can open that
 * connector instead of guessing.
 */
export function scanResultToPath(result: QRScanResult): string {
  if (result.type === 'chargepoint' && result.chargePointId) {
    const gunQuery = result.gun ? `?gun=${encodeURIComponent(result.gun)}` : '';
    return `/app/location/${result.locationId}/chargepoint/${result.chargePointId}${gunQuery}`;
  }
  return `/app/location/${result.locationId}`;
}

/**
 * Search string to apply when the scanner overlay closes.
 *
 * Returns null when the close must not touch search — a successful scan has
 * already navigated (possibly with ?gun=), and rewriting search from the
 * stale ?qr=true snapshot would wipe that gun.
 */
export function nextSearchAfterScannerClose(
  currentSearch: string,
  opts: { didScanNavigate: boolean },
): string | null {
  if (opts.didScanNavigate) return null;
  const next = new URLSearchParams(currentSearch);
  next.delete('qr');
  const s = next.toString();
  return s ? `?${s}` : '';
}
